import React, { Component } from "react"
import { connect, getIn } from "formik"
import DateRange from "../DateRange"
import _ from "lodash"

class FormikDateRange extends Component {
  props: {
    formik: any,
    name: string,
  }

  render () {
    const inputProps = _.omit( this.props, [ "formik" ] )

    const { name, formik } = this.props
    const error = getIn( formik.errors, name )
    const touched = getIn( formik.touched, name )
    const value = getIn( formik.values, name )

    return (
      <DateRange
        {...inputProps}
        value={value}
        error={touched && error ? error : undefined}
        onChange={date => formik.setFieldValue( name, date )}
        onBlur={formik.handleBlur( name )}
      />
    )
  }
}

export default connect( FormikDateRange )



// WEBPACK FOOTER //
// ./src/components/FormikComponents/DateRange.jsx